import axios from 'axios';
import download from 'downloadjs';
import { uploadingStatus } from '../../actions/ProposalsEditor';
import EventBus from 'eventing-bus';
import { baseURL } from './api';

const apiVersion = 'v2';
const path = process.env.REACT_APP_BASE_URL + '/api/';

class ProposalService {
  static baseURL = baseURL;

  static resourcePath = path || '';

  constructor(api, demo = false, baseURLOverride) {
    this.api = api;
    this.demo = demo;
    this.baseURL = baseURLOverride;
  }

  getBaseURL = () => {
    return this.baseURL || ProposalService.resourcePath || ProposalService.baseURL;
  };

  getPaginateOptions = options => {
    return JSON.stringify(options || { page: 1, limit: 10 });
  };

  async getProductGroups(companyId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/companies/${companyId}/productGroups`,
      { headers },
    );
    return data;
  }

  async getOneTimeChargeGroups(companyId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/companies/${companyId}/oneTimeChargeGroups`,
      { headers },
    );
    // var data = [
    //   {
    //     _id: '5f1855333b57370a50c6e3cf',
    //     groupName: 'Life Safety Analog Line',
    //     deleted: false,
    //     company: '5c0fa292845f46059f1c1ce1',
    //     products: [
    //       {
    //         name: 'Burglar Alarm Line',
    //         description: 'Burglar Alarm Line',
    //         _id: '5f1855333b57370a50c6e3d3',
    //         price: 39.95,
    //       },
    //       {
    //         name: 'Elevator Line',
    //         description: 'Elevator Line',
    //         _id: '5f1855333b57370a50c6e3d2',
    //         price: 49.95,
    //       },
    //       {
    //         name: 'Fire Alarm Line',
    //         description: 'Fire Alarm Line',
    //         _id: '5f1855333b57370a50c6e3d1',
    //         price: 59.95,
    //       },
    //       {
    //         name: 'Security Alarm Line',
    //         description: 'Security Alarm Line',
    //         _id: '5f1855333b57370a50c6e3d0',
    //         price: 59.95,
    //       },
    //     ],
    //     __v: 0,
    //   },
    //   {
    //     _id: '5f18569e3b57370a50c6e3d4',
    //     groupName: 'Analog Lines',
    //     deleted: false,
    //     company: '5c0fa292845f46059f1c1ce1',
    //     products: [
    //       {
    //         name: 'Analog Voice Line',
    //         description: 'Analog Voice Line',
    //         _id: '5f18569e3b57370a50c6e3dc',
    //         price: 99.99,
    //       },
    //       {
    //         name: 'Door / Gate Entry',
    //         description: 'Door / Gate Entry',
    //         _id: '5f18569e3b57370a50c6e3db',
    //         price: 89.99,
    //       },
    //       {
    //         name: 'New Item',
    //         description: 'New item description',
    //         _id: '5f18569e3b57370a50c6e3da',
    //         price: 79.99,
    //       },
    //       {
    //         name: 'Fax Line',
    //         description: 'Fax Line',
    //         _id: '5f18569e3b57370a50c6e3d9',
    //         price: 69.99,
    //       },
    //       {
    //         name: 'Overhead Paging Line',
    //         description: 'Overhead Paging Line',
    //         _id: '5f18569e3b57370a50c6e3d8',
    //         price: 59.99,
    //       },
    //       {
    //         name: 'POS Line',
    //         description: 'POS Line',
    //         _id: '5f18569e3b57370a50c6e3d7',
    //         price: 49.99,
    //       },
    //       {
    //         name: 'SCADA Line',
    //         description: 'SCADA Line',
    //         _id: '5f18569e3b57370a50c6e3d6',
    //         price: 39.99,
    //       },
    //       {
    //         name: '*Toll-Free 500 Voice Line',
    //         description: '*Toll-Free 500 Voice Line',
    //         _id: '5f18569e3b57370a50c6e3d5',
    //         price: 29.99,
    //       },
    //     ],
    //     __v: 0,
    //   },
    //   {
    //     _id: '5f1857513b57370a50c6e3dd',
    //     groupName: 'Lines & Numbers',
    //     deleted: false,
    //     company: '5c0fa292845f46059f1c1ce1',
    //     products: [
    //       {
    //         name: 'Single DID',
    //         description: 'Single DID',
    //         _id: '5f1857513b57370a50c6e3e6',
    //         price: 199.99,
    //       },
    //       {
    //         name: '20 Local DIDs',
    //         description: '20 Local DIDs',
    //         _id: '5f1857513b57370a50c6e3e5',
    //         price: 299.99,
    //       },
    //       {
    //         name: '50 Local DIDs',
    //         description: '50 Local DIDs',
    //         _id: '5f1857513b57370a50c6e3e4',
    //         price: 399.99,
    //       },
    //       {
    //         name: '100 Local DIDs',
    //         description: '100 Local DIDs',
    //         _id: '5f1857513b57370a50c6e3e3',
    //         price: 499.99,
    //       },
    //       {
    //         name: 'Fax DID',
    //         description: 'Fax DID',
    //         _id: '5f1857513b57370a50c6e3e2',
    //         price: 599.99,
    //       },
    //       {
    //         name: 'Out of Rate Center DID',
    //         description: 'Out of Rate Center DID',
    //         _id: '5f1857513b57370a50c6e3e1',
    //         price: 699.99,
    //       },
    //       {
    //         name: 'eFax Line',
    //         description: 'eFax Line',
    //         _id: '5f1857513b57370a50c6e3e0',
    //         price: 799.99,
    //       },
    //       {
    //         name: 'Toll-Free Number',
    //         description: 'Toll-Free Number',
    //         _id: '5f1857513b57370a50c6e3df',
    //         price: 899.99,
    //       },
    //       {
    //         name: 'Unlimited Domestic DID',
    //         description: 'Unlimited Domestic DID',
    //         _id: '5f1857513b57370a50c6e3de',
    //         price: 999.99,
    //       },
    //     ],
    //     __v: 0,
    //   },
    //   {
    //     _id: '5f1857fb3b57370a50c6e3e7',
    //     groupName: 'Minutes',
    //     deleted: false,
    //     company: '5c0fa292845f46059f1c1ce1',
    //     products: [
    //       {
    //         name: '1000 Toll-Free Minutes',
    //         description: '1000 Toll-Free Minutes',
    //         _id: '5f1857fb3b57370a50c6e3eb',
    //         price: 99.99,
    //       },
    //       {
    //         name: '2500 Toll-Free Minutes',
    //         description: '2500 Toll-Free Minutes',
    //         _id: '5f1857fb3b57370a50c6e3ea',
    //         price: 199.99,
    //       },
    //       {
    //         name: '5000 Toll-Free Minutes',
    //         description: '5000 Toll-Free Minutes',
    //         _id: '5f1857fb3b57370a50c6e3e9',
    //         price: 299.99,
    //       },
    //       {
    //         name: '10000 Toll-Free Minutes',
    //         description: '10000 Toll-Free Minutes',
    //         _id: '5f1857fb3b57370a50c6e3e8',
    //         price: 399.99,
    //       },
    //     ],
    //     __v: 0,
    //   },
    //   {
    //     _id: '5f18587a3b57370a50c6e3ec',
    //     groupName: 'Features',
    //     deleted: false,
    //     company: '5c0fa292845f46059f1c1ce1',
    //     products: [
    //       {
    //         name: '**Call Queing',
    //         description: '**Call Queing',
    //         _id: '5f18587a3b57370a50c6e3f4',
    //         price: 99.99,
    //       },
    //       {
    //         name: '**Call Recording',
    //         description: '**Call Recording',
    //         _id: '5f18587a3b57370a50c6e3f3',
    //         price: 199.99,
    //       },
    //       {
    //         name: '**Call Recording & Queing',
    //         description: '**Call Recording & Queing',
    //         _id: '5f18587a3b57370a50c6e3f2',
    //         price: 299.99,
    //       },
    //       {
    //         name: '**Voicemail to Email / Text Transcription',
    //         description: '**Voicemail to Email / Text Transcription',
    //         _id: '5f18587a3b57370a50c6e3f1',
    //         price: 399.99,
    //       },
    //       {
    //         name: '***Unlimited Data Backup',
    //         description: '***Unlimited Data Backup',
    //         _id: '5f18587a3b57370a50c6e3f0',
    //         price: 499.99,
    //       },
    //       {
    //         name: '**Conference Bridge',
    //         description: '**Conference Bridge',
    //         _id: '5f18587a3b57370a50c6e3ef',
    //         price: 599.99,
    //       },
    //       {
    //         name: '4G LTE',
    //         description: '4G LTE',
    //         _id: '5f18587a3b57370a50c6e3ee',
    //         price: 699.99,
    //       },
    //       {
    //         name: '4G Network Monitoring',
    //         description: '4G Network Monitoring',
    //         _id: '5f18587a3b57370a50c6e3ed',
    //         price: 799.99,
    //       },
    //     ],
    //     __v: 0,
    //   },
    //   {
    //     _id: '5f1859e73b57370a50c6e3f5',
    //     groupName: 'PRI/SIP',
    //     deleted: false,
    //     company: '5c0fa292845f46059f1c1ce1',
    //     products: [
    //       {
    //         name: 'Primary PRI',
    //         description: 'Primary PRI',
    //         _id: '5f1859e73b57370a50c6e3f8',
    //         price: 500,
    //       },
    //       {
    //         name: 'Backup PRI',
    //         description: 'Backup PRI',
    //         _id: '5f1859e73b57370a50c6e3f7',
    //         price: 600,
    //       },
    //       {
    //         name: 'PRI / SIP Channel',
    //         description: 'PRI / SIP Channel',
    //         _id: '5f1859e73b57370a50c6e3f6',
    //         price: 700,
    //       },
    //     ],
    //     __v: 0,
    //   },
    //   {
    //     _id: '5f185a623b57370a50c6e3f9',
    //     groupName: 'Misc Epik',
    //     deleted: true,
    //     company: '5c0fa292845f46059f1c1ce1',
    //     products: [
    //       {
    //         name: 'asdasd',
    //         description: '<product description>',
    //         _id: '5f185a623b57370a50c6e3fb',
    //         price: 100,
    //       },
    //       {
    //         name: 'qweqwe',
    //         description: '',
    //         _id: '5f185a623b57370a50c6e3fa',
    //         price: 200,
    //       },
    //     ],
    //     __v: 0,
    //   },
    //   {
    //     _id: '5f185abb3b57370a50c6e3fc',
    //     groupName: 'Fax PRI',
    //     deleted: false,
    //     company: '5c0fa292845f46059f1c1ce1',
    //     products: [
    //       {
    //         name: 'Primary Fax PRI',
    //         description: 'Primary Fax PRI',
    //         _id: '5f185abb3b57370a50c6e3fe',
    //         price: 200,
    //       },
    //       {
    //         name: 'Fax SIP Channel',
    //         description: 'Fax SIP Channel',
    //         _id: '5f185abb3b57370a50c6e3fd',
    //         price: 300,
    //       },
    //     ],
    //     __v: 0,
    //   },
    // ];
    return data;
  }

  async getInstallationGroups(companyId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/companies/${companyId}/oneTimeChargeGroups?type=installation`,
      { headers },
    );
    // var data = [
    //   {
    //     _id: '5f1855333b57370a50c6e3cf',
    //     groupName: 'Life Safety Analog Line',
    //     deleted: false,
    //     company: '5c0fa292845f46059f1c1ce1',
    //     products: [
    //       {
    //         name: 'Burglar Alarm Line',
    //         description: 'Burglar Alarm Line',
    //         _id: '5f1855333b57370a50c6e3d3',
    //         price: 39.95,
    //       },
    //       {
    //         name: 'Elevator Line',
    //         description: 'Elevator Line',
    //         _id: '5f1855333b57370a50c6e3d2',
    //         price: 49.95,
    //       },
    //       {
    //         name: 'Fire Alarm Line',
    //         description: 'Fire Alarm Line',
    //         _id: '5f1855333b57370a50c6e3d1',
    //         price: 59.95,
    //       },
    //       {
    //         name: 'Security Alarm Line',
    //         description: 'Security Alarm Line',
    //         _id: '5f1855333b57370a50c6e3d0',
    //         price: 59.95,
    //       },
    //     ],
    //     __v: 0,
    //   },
    //   {
    //     _id: '5f18569e3b57370a50c6e3d4',
    //     groupName: 'Analog Lines',
    //     deleted: false,
    //     company: '5c0fa292845f46059f1c1ce1',
    //     products: [
    //       {
    //         name: 'Analog Voice Line',
    //         description: 'Analog Voice Line',
    //         _id: '5f18569e3b57370a50c6e3dc',
    //         price: 99.99,
    //       },
    //       {
    //         name: 'Door / Gate Entry',
    //         description: 'Door / Gate Entry',
    //         _id: '5f18569e3b57370a50c6e3db',
    //         price: 89.99,
    //       },
    //       {
    //         name: 'New Item',
    //         description: 'New item description',
    //         _id: '5f18569e3b57370a50c6e3da',
    //         price: 79.99,
    //       },
    //       {
    //         name: 'Fax Line',
    //         description: 'Fax Line',
    //         _id: '5f18569e3b57370a50c6e3d9',
    //         price: 69.99,
    //       },
    //       {
    //         name: 'Overhead Paging Line',
    //         description: 'Overhead Paging Line',
    //         _id: '5f18569e3b57370a50c6e3d8',
    //         price: 59.99,
    //       },
    //       {
    //         name: 'POS Line',
    //         description: 'POS Line',
    //         _id: '5f18569e3b57370a50c6e3d7',
    //         price: 49.99,
    //       },
    //       {
    //         name: 'SCADA Line',
    //         description: 'SCADA Line',
    //         _id: '5f18569e3b57370a50c6e3d6',
    //         price: 39.99,
    //       },
    //       {
    //         name: '*Toll-Free 500 Voice Line',
    //         description: '*Toll-Free 500 Voice Line',
    //         _id: '5f18569e3b57370a50c6e3d5',
    //         price: 29.99,
    //       },
    //     ],
    //     __v: 0,
    //   },
    //   {
    //     _id: '5f1857513b57370a50c6e3dd',
    //     groupName: 'Lines & Numbers',
    //     deleted: false,
    //     company: '5c0fa292845f46059f1c1ce1',
    //     products: [
    //       {
    //         name: 'Single DID',
    //         description: 'Single DID',
    //         _id: '5f1857513b57370a50c6e3e6',
    //         price: 199.99,
    //       },
    //       {
    //         name: '20 Local DIDs',
    //         description: '20 Local DIDs',
    //         _id: '5f1857513b57370a50c6e3e5',
    //         price: 299.99,
    //       },
    //       {
    //         name: '50 Local DIDs',
    //         description: '50 Local DIDs',
    //         _id: '5f1857513b57370a50c6e3e4',
    //         price: 399.99,
    //       },
    //       {
    //         name: '100 Local DIDs',
    //         description: '100 Local DIDs',
    //         _id: '5f1857513b57370a50c6e3e3',
    //         price: 499.99,
    //       },
    //       {
    //         name: 'Fax DID',
    //         description: 'Fax DID',
    //         _id: '5f1857513b57370a50c6e3e2',
    //         price: 599.99,
    //       },
    //       {
    //         name: 'Out of Rate Center DID',
    //         description: 'Out of Rate Center DID',
    //         _id: '5f1857513b57370a50c6e3e1',
    //         price: 699.99,
    //       },
    //       {
    //         name: 'eFax Line',
    //         description: 'eFax Line',
    //         _id: '5f1857513b57370a50c6e3e0',
    //         price: 799.99,
    //       },
    //       {
    //         name: 'Toll-Free Number',
    //         description: 'Toll-Free Number',
    //         _id: '5f1857513b57370a50c6e3df',
    //         price: 899.99,
    //       },
    //       {
    //         name: 'Unlimited Domestic DID',
    //         description: 'Unlimited Domestic DID',
    //         _id: '5f1857513b57370a50c6e3de',
    //         price: 999.99,
    //       },
    //     ],
    //     __v: 0,
    //   },
    // ];
    return data;
  }

  async getProductGroupsVerizon() {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/productGroups/verizonProducts`,
      { headers },
    );
    return data;
  }

  async getProposals(paginateOptions, status = 'all') {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const options = this.getPaginateOptions(paginateOptions);

    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/proposals?paginateOptions=${options}&type=${status}`,
      { headers },
    );
    return data;
  }

  async getProposalsByCompany(companyId, paginateOptions, status = 'all') {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const options = this.getPaginateOptions(paginateOptions);

    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/companies/${companyId}/proposals?paginateOptions=${options}&type=${status}`,
      { headers },
    );
    return data;
  }

  async getProposalsById(userId, paginateOptions, status = 'all') {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const options = this.getPaginateOptions(paginateOptions);

    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/users/${userId}/proposals?paginateOptions=${options}&type=${status}`,
      { headers },
    );
    return data;
  }

  async deletedProposal(id) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.delete(`${this.getBaseURL()}${apiVersion}/proposals/${id}`, {
      headers,
    });
    return data;
  }

  async downloadProposal(uuid, agencyId, logo) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    try {
      const companyLogo = logo === null ? 'null' : `${agencyId}`;
      const res = await axios.get(
        `${this.getBaseURL()}${apiVersion}/proposals/sign/download/${uuid}?agencyId=${companyLogo}`,
        {
          headers,
          responseType: 'blob',
        },
      );
      download(res.data, `Proposal-${uuid}.pdf`, 'application/pdf');
    } catch (error) {
      // handle error
    }
  }

  async saveProposal(userId, proposal) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(
      `${this.getBaseURL()}${apiVersion}/users/${userId}/proposals`,
      proposal,
      {
        headers,
      },
    );
    return data;
  }

  async uploadSignedContract(id, file) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const uploadedFile = new FormData();
    uploadedFile.append('signedContract', file);

    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/proposals/${id}/signedContract`,
      uploadedFile,
      {
        headers,
      },
    );
    return data;
  }

  async updateProposal(proposalId, proposal) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/proposals/${proposalId}`,
      proposal,
      {
        headers,
      },
    );
    return data;
  }

  async deleteAttachment(id, path) {
    var optionsAxios = {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${this.api.token}`,
      },
      url: `${this.getBaseURL()}${apiVersion}/proposals/${id}/attachments`,
      data: {
        attachmentPath: path,
      },
    };

    let { data } = await axios(optionsAxios);
    return data;
  }

  async getProposalById(proposalId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(`${this.getBaseURL()}${apiVersion}/proposals/${proposalId}`, {
      headers,
    });
    return data;
  }

  async getProposalByKey(uuid) {
    const { data } = await axios.get(`${this.getBaseURL()}${apiVersion}/proposals/sign/${uuid}`);
    return data;
  }

  async updateProposalSigned(uuid, proposal) {
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/proposals/sign/${uuid}`,
      proposal,
    );
    return data;
  }

  async updateLogo(id, files) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };

    const { data } = await axios.post(
      `${this.getBaseURL()}${apiVersion}/proposals/${id}/logo`,
      files,
      {
        headers,
      },
    );
    return data;
  }

  async getLogoByCompany(cid) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };

    const { data } = await axios.get(`${this.getBaseURL()}${apiVersion}/companies/${cid}/logo/`, {
      responseType: 'arraybuffer',
      headers,
    });

    const blob = new Blob([data], {
      type: 'image/png',
    });
    const urlCreator = window.URL || window.webkitURL;
    const imageUrl = urlCreator.createObjectURL(blob);

    return imageUrl;
  }

  // localhost:3000/api/v2/cities/states
  async getStateCountry() {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };

    const { data } = await axios.get(`${this.getBaseURL()}${apiVersion}/states`, {
      headers,
    });
    return data;
  }

  async getStateCodesApi() {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };

    const { data } = await axios.get(`${this.getBaseURL()}${apiVersion}/states?code=true`, {
      headers,
    });
    return data;
  }

  // localhost:3000/api/v2/cities?state=<statename>
  async getCityOfState(state) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };

    const { data } = await axios.get(`${this.getBaseURL()}${apiVersion}/states/${state}/cities`, {
      headers,
    });
    return data;
  }

  // proposalRouter.post(`/:id/attachments`, async (req, res) => {
  async uploadAttachments(id, filesObj) {
    const { files, idx } = filesObj;
    global.source = {};
    // if (files.length >= 2) {
    //   files.forEach(async (item, idx) => {
    //     const CancelToken = axios.CancelToken;
    //     global.source[`${idx.toString()}`] = CancelToken.source();
    //     const file = new FormData();
    //     file.append('files', item);
    //     var optionsAxios = {
    //       method: 'POST',
    //       cancelToken: global.source[`${idx.toString()}`].token,
    //       headers: {
    //         Authorization: `Bearer ${this.api.token}`,
    //       },
    //       url: `${this.getBaseURL()}${apiVersion}/proposals/${id}/attachments`,
    //       data: file,
    //       onUploadProgress: p => {
    //         let progress = ((p.loaded / p.total) * 100).toFixed(2);
    //         EventBus.publish('uploadingProgress', {progress, idx});
    //       },
    //     };
    //     const { data } = await axios(optionsAxios);
    //     return data;
    //   });
    // } else {
    const CancelToken = axios.CancelToken;
    global.source['0'] = CancelToken.source();
    const file = new FormData();
    file.append('files', files[0]);
    file.append('index', idx);
    var optionsAxios = {
      method: 'POST',
      cancelToken: global.source['0'].token,
      headers: {
        Authorization: `Bearer ${this.api.token}`,
      },
      url: `${this.getBaseURL()}${apiVersion}/proposals/${id}/attachments`,
      data: file,
      onUploadProgress: p => {
        let progress = ((p.loaded / p.total) * 100).toFixed(2);
        EventBus.publish('uploadingProgress', { progress, idx });
      },
    };

    // console.log('options :: ', optionsAxios);
    let { data } = await axios(optionsAxios);
    // console.log('rec data :: ', data);
    data['idx'] = idx;
    data['name'] = files[0].name;
    // console.log('rec data after :: ', data);
    return data;
    // }
  }

  // proposalRouter.post(`/:id`, async (req, res) => {
  async onSendEmail(id, email) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };

    const { data } = await axios.post(
      `${this.getBaseURL()}${apiVersion}/proposals/${id}`,
      { email },
      {
        headers,
      },
    );
    return data;
  }
}

export default ProposalService;
